export default "/images/grolm.gif?0cb118f39890d299156af605df6da95a";